import { surnameDeleteApi } from "../../api/surname/surnameDeleteApi"

type PayloadShape = Parameters<typeof surnameDeleteApi>[0]

export async function surnameDeleteService(payload: PayloadShape, token: string) {
	return await surnameDeleteApi(payload, token)
}
